var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/~/lodash/_coreJsData.js
 ** module id = 2872
 ** module chunks = 0
 **/